import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../../services/api';

interface SurveyParams {
  accessId?: string;
  code?: string;
}

const listAllowedAccessRedirection = ['2092', '2093', '2421'];

const RedirectionOldLinks: React.FC = () => {
  const { accessId, code } = useParams();

  useEffect(() => {
    const params: SurveyParams = {
      accessId,
      code,
    };

    if (accessId && listAllowedAccessRedirection.includes(accessId)) {
      api.get(`/accesses/${params.accessId}/full`).then(response => {
        // eslint-disable-next-line no-underscore-dangle
        const objectId = response.data._id;
        const parameters = window.location.href.split('?')[1];

        if (objectId) {
          const newUrl = `https://meine-sicht.com/questionnaire/${objectId}/${params.accessId}?${parameters}`;
          window.location.replace(newUrl);
        }
      });
    }
  }, [accessId, code]);

  return <></>;
};

export default RedirectionOldLinks;
